import { render } from "./createpurchasereturn.vue?vue&type=template&id=6345533a"
import script from "./createpurchasereturn.vue?vue&type=script&lang=js"
export * from "./createpurchasereturn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__